<template>
  <v-container>
    <v-row no-gutters>
      <v-col>
        <CompaniesTable></CompaniesTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CompaniesTable from "./tables/CompaniesTable.vue";
export default {
  name: "Firmen",
  components: {
    CompaniesTable,
  },
  data() {
    return {
      msg: "Firmen",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
